<template>
    <div>
        <div class="title">
            <h4 class="mb-0">Payment Methods</h4>
        </div>
        <div
            class="d-flex justify-content-end mb-3"
            v-if="_hasAccess('setting.payment.add')"
        >
            <button
                type="button"
                class="btn"
                style="background-color: #e1e1e1; width: 80px"
                @click="addPaymentMethod"
            >
                <spinner v-if="isLoadingAddModal" />
                <span v-else>Add New</span>
            </button>
        </div>
        <div>
            <LoaderList v-if="isLoading" class="w-100" />
            <div v-else class="table-responsive">
                <table class="table list">
                    <thead>
                        <tr>
                            <th>Card Type:</th>
                            <th>Card Number:</th>
                            <th>Name On Card:</th>
                            <th>Expiration:</th>
                            <th>Primary:</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody v-if="paymentMethods && paymentMethods.length">
                        <template v-for="paymentMethod in paymentMethods">
                            <tr
                                :key="'row-' + paymentMethod.id"
                                :id="'row-' + paymentMethod.id"
                            >
                                <td>{{ paymentMethod.card_network }}</td>
                                <td>xxx{{ paymentMethod.last_four_digit }}</td>
                                <td>{{ paymentMethod.name }}</td>
                                <td>
                                    {{
                                        `${paymentMethod.expiration_month}/${paymentMethod.expiration_year}`
                                    }}
                                </td>
                                <td>
                                    {{
                                        paymentMethod.is_primary ? "Yes" : "No"
                                    }}
                                </td>

                                <td class="text-right small text-nowrap">
                                    <div>
                                        <span
                                            style="cursor: pointer"
                                            v-if="
                                                !paymentMethod.is_primary &&
                                                _hasAccess(
                                                    'setting.payment.edit'
                                                )
                                            "
                                            @click="
                                                makePrimaryPaymentMethod(
                                                    paymentMethod
                                                )
                                            "
                                            >Make Primary</span
                                        >
                                        <span
                                            v-if="
                                                !paymentMethod.is_primary &&
                                                _hasAccess(
                                                    'setting.payment.edit'
                                                ) &&
                                                isDeleteEnabled
                                            "
                                        >
                                            |
                                        </span>
                                        <span
                                            v-if="isDeleteEnabled"
                                            style="cursor: pointer"
                                            @click="
                                                deletePaymentMethod(
                                                    paymentMethod
                                                )
                                            "
                                            >Delete</span
                                        >
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td :colspan="9">
                                <i>No records available</i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div>
            <pagination
                :current-page="filter.page"
                :totalPages="totalPages"
                :isLoading="isLoading"
                @change-page="page => changePage(page)"
            />
        </div>
        <div>
            <ModalPaymentMethodDelete
                ref="ModalPaymentMethodDelete"
                @getPaymentMethods="getPaymentMethods"
            />
            <ModalPaymentMethodAdd
                ref="ModalPaymentMethodAdd"
                @getPaymentMethods="getPaymentMethods"
                @updateIsLoadingAddModal="updateIsLoadingAddModal"
            />
            <ModalPaymentMethodChangePrimary
                ref="ModalPaymentMethodChangePrimary"
                @getPaymentMethods="getPaymentMethods"
            />
        </div>
    </div>
</template>

<script>
import subscriptionService from "@/services/subscription";

export default {
    components: {
        LoaderList: () => import("@/components/elements/loader-list.vue"),
        Pagination: () => import("@/components/commons/pagination.vue"),
        Spinner: () => import("@/components/elements/spinner.vue"),
        ModalPaymentMethodDelete: () =>
            import(
                "@/components/setting-subscription/payment-method-delete.vue"
            ),
        ModalPaymentMethodAdd: () =>
            import("@/components/setting-subscription/payment-method-add.vue"),
        ModalPaymentMethodChangePrimary: () =>
            import(
                "@/components/setting-subscription/payment-method-change-primary.vue"
            )
    },
    data() {
        return {
            isLoading: true,
            isLoadingAddModal: false,
            paymentMethods: [],
            totalPages: 0,
            filter: {
                perPage: 20,
                page: 1
            }
        };
    },
    computed: {
        isDeleteEnabled() {
            if (this.paymentMethods && this.paymentMethods.length === 1) {
                return false;
            }

            if (this._hasAccess("setting.payment.delete")) {
                return true;
            } else {
                return false;
            }
        }
    },
    created() {
        this.getPaymentMethods();
    },
    methods: {
        async getPaymentMethods(page = null) {
            this.isLoading = true;

            if (page) {
                this.filter.page = page;
            }

            const response = await subscriptionService.getPaymentMethods(
                this.filter
            );

            if (
                response.message &&
                response.message.code &&
                response.message.code == 200
            ) {
                const { meta, resources } = response;
                if (meta && resources) {
                    this.paymentMethods = resources;
                    this.totalPages = meta.lastPage;
                }
            }

            this.isLoading = false;
        },
        changePage(page) {
            this.filter.page = page;
        },
        deletePaymentMethod(paymentMethod) {
            this.$refs.ModalPaymentMethodDelete.open(paymentMethod);
        },
        addPaymentMethod(paymentMethod) {
            if (this.isLoadingAddModal) return;
            this.$refs.ModalPaymentMethodAdd.open(paymentMethod);
        },
        makePrimaryPaymentMethod(paymentMethod) {
            this.$refs.ModalPaymentMethodChangePrimary.open(paymentMethod);
        },
        updateIsLoadingAddModal(isLoading) {
            this.isLoadingAddModal = isLoading;
        }
    },
    watch: {
        filter: {
            handler() {
                this.getPaymentMethods();
            },
            deep: true
        }
    }
};
</script>

<style scoped></style>
